import http from '@/support/services/HttpService';

class ReportRequest {
  static baseUrl() {
    throw Error('Method baseUrl not implemented');
  }

  static generate(queryParams = {}) {
    return http.get(this.baseUrl(), { params: queryParams });
  }
}

export default ReportRequest;
